import UrlPattern from "url-pattern";
import { checkIfClient } from "./utils";

/**
 * Only use this in the top level NextPage.
 * Using this in subcomponents can lead to errors.
 * Next file structure makes it more reliable that a
 * UrlParam is guaranteed to be there when we use [id] file name format,
 * whereas for modules this is not the case.
 *
 * https://www.npmjs.com/package/url-pattern
 *
 * @param template = "/api/users(/:id)"
 * @returns { id } | null
 */
export const getUrlParams = (template = "/") => {
  if (checkIfClient()) {
    const pattern = new UrlPattern(template, {
      segmentNameCharset: "a-zA-Z0-9_-",
    });

    return pattern.match(new URL(window.location.href)?.pathname);
  }

  return null;
};
